import { render, staticRenderFns } from "./ProfileBlurBanner.vue?vue&type=template&id=4bff22d7&scoped=true&lang=html"
import script from "./ProfileBlurBanner.vue?vue&type=script&lang=js"
export * from "./ProfileBlurBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bff22d7",
  null
  
)

export default component.exports